import React from 'react';
import { bool, shape, string } from 'prop-types';

const GarbageWorks = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM16 9V19H8V9H16ZM6 7H18V19C18 20.1 17.1 21 16 21H8C6.9 21 6 20.1 6 19V7Z" fill="currentColor" />
  </svg>
);

GarbageWorks.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default GarbageWorks;
